









import { defineComponent } from '@vue/composition-api';
import AppText from '@berlin-front/common/components/elements/AppText';
import AppLink from '@berlin-front/common/components/elements/AppLink';
import { useRouter } from '@berlin-front/common/composables/useRouter';
import { TEXT_WEIGHT } from '@berlin-front/common/components/elements/AppText/composable';
import { bemx } from '@berlin-front/common/utils';
import useAtoneLogout from '@services/useAtoneLogout';
import { ROUTE_NAME } from '@/router/route-name';

/**
 * ## ユーザー名表示フッター
 *
 * ログイン状態で表示されるフッター。
 * ログイン中のユーザー名とログアウトリンクで構成される。
 *
 */
export default defineComponent({
  name: 'UserNameFooter',
  components: {
    AppLink,
    AppText,
  },

  props: {
    /**
     * ユーザー名
     */
    userName: {
      type: String,
      required: true,
    },
  },

  setup() {
    const { isLogouting, logout } = useAtoneLogout();
    const router = useRouter();

    const onLogout = () => {
      logout({
        deleteToken: true,
        onLogout: () => {
          void router.replace({
            name: ROUTE_NAME.ATONE_LOGIN_ATONE,
          });
        },
      });
    };

    const className = bemx('UserNameFooter');
    return {
      className,
      isLogouting,
      onLogout,
      TEXT_WEIGHT,
    };
  },
});
